var map = {
	"./assets/beep.mp3": 3722,
	"./assets/css/style.css": 462,
	"./assets/images/404_error_page.png": 3936,
	"./assets/images/Under Construction Illustration.png": 2754,
	"./assets/images/account-hover.png": 1227,
	"./assets/images/account-logo.png": 5576,
	"./assets/images/account-management.png": 3484,
	"./assets/images/announcement.png": 742,
	"./assets/images/card-img.jpg": 8611,
	"./assets/images/clinet-gv.jpg": 4204,
	"./assets/images/cvs-icon.png": 2923,
	"./assets/images/dashboard-hover.png": 6346,
	"./assets/images/dashboard-icon.png": 8813,
	"./assets/images/doc-icon.png": 5783,
	"./assets/images/dummy-logo-0424-1.jpg": 4242,
	"./assets/images/dummy-logo-0424-2.jpg": 4141,
	"./assets/images/dummy-logo-0424-3.jpg": 8560,
	"./assets/images/dummy-logo-1.png": 929,
	"./assets/images/google-pixel-4.png": 1602,
	"./assets/images/history-icon.svg": 8381,
	"./assets/images/inbound-hover.png": 2373,
	"./assets/images/inbound-icon.png": 2328,
	"./assets/images/inquiry-hover.png": 3321,
	"./assets/images/inquiry-report.png": 6001,
	"./assets/images/inventory-hover.png": 4338,
	"./assets/images/inventory-management.png": 2960,
	"./assets/images/jpg-icon.png": 5962,
	"./assets/images/login/announcement.png": 3100,
	"./assets/images/login/bg.png": 2744,
	"./assets/images/login/login-image.png": 1406,
	"./assets/images/login/loginRightImage.svg": 8485,
	"./assets/images/login/logo-white.png": 3192,
	"./assets/images/login/logo.png": 5704,
	"./assets/images/login/password.svg": 9950,
	"./assets/images/login/userEmail.svg": 680,
	"./assets/images/noimage.png": 8863,
	"./assets/images/outbound-hover.png": 9330,
	"./assets/images/outbound-icon.png": 373,
	"./assets/images/pdf -icon.png": 9979,
	"./assets/images/phone1.jpg": 202,
	"./assets/images/png-icon.png": 4626,
	"./assets/images/sort-down-active 1.svg": 7590,
	"./assets/images/sort-icon.svg": 7059,
	"./assets/images/sort-up-active 1.svg": 735,
	"./assets/images/sphere-wms-logo.png": 378,
	"./assets/images/svgList": 4445,
	"./assets/images/svgList.tsx": 4445,
	"./assets/images/timeline-circle.svg": 4195,
	"./assets/images/warning.svg": 4137,
	"./assets/images/xbox.png": 5792
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5353;